import "js/studios/shared/app_base"
import React, {useCallback} from "react"
import {createRoot} from "react-dom/client"
import {Provider} from 'react-redux'
import {ErrorBoundary} from 'js/studios/shared/error_boundary'
import {registerReducer} from 'js/studios/shared/redux/utils'
import {SignIn} from 'js/studios/shared/reg/panels/sign_in'
import {onPageReady} from 'js/studios/shared/utils'

function user(state={}, action) {
  switch (action.type) {
    case "USER_LOGIN":
      return action.user
    default:
      return state
  }
}
registerReducer(user, 'user', true)

function LoginApp() {
  const onSuccess = useCallback(({resp}) => {
    return new Promise((_resolve, _reject) => {
      window.location = resp?.postLoginUrl || "/studios/account"
    })
  }, [])

  return <SignIn analyticsSource="login" onSuccess={onSuccess}>
    <p className="txt--body-2 mt--lg">Don't have an account yet?</p>
    <div className="btn-group btn-group--stack field--md">
      <a href={window.cm.urls['project-creation']} className="btn btn--lg">Start a project</a>
    </div>
  </SignIn>
}

onPageReady(() => {
  createRoot(document.getElementById("login-app")).render(
    <ErrorBoundary>
      <Provider store={window.cm.store}><LoginApp /></Provider>
    </ErrorBoundary>
  )
})
